import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { updateSession, Scope } from '@sentry/hub';
import { makeDsn, logger, checkOrSetAlreadyCaught, isPrimitive, resolvedSyncPromise, addItemToEnvelope, createAttachmentEnvelopeItem, SyncPromise, uuid4, dateTimestampInSeconds, normalize, truncate, rejectedSyncPromise, SentryError, isThenable, isPlainObject } from '@sentry/utils';
import { getEnvelopeEndpointWithUrlEncodedAuth } from './api.js';
import { createEventEnvelope, createSessionEnvelope } from './envelope.js';
import { setupIntegrations as _setupIntegrations } from './integration.js';
var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */

var BaseClient = /*#__PURE__*/function () {
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  function BaseClient(options) {
    _classCallCheck(this, BaseClient);

    ;

    BaseClient.prototype.__init.call(this);

    BaseClient.prototype.__init2.call(this);

    BaseClient.prototype.__init3.call(this);

    BaseClient.prototype.__init4.call(this);

    this._options = options;

    if (options.dsn) {
      this._dsn = makeDsn(options.dsn);
      var url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel);
      this._transport = options.transport(_objectSpread(_objectSpread({
        recordDroppedEvent: this.recordDroppedEvent.bind(this)
      }, options.transportOptions), {}, {
        url: url
      }));
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('No DSN provided, client will not do anything.');
    }
  }
  /**
   * @inheritDoc
   */


  _createClass(BaseClient, [{
    key: "__init",
    value:
    /** Options passed to the SDK. */

    /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

    /** Array of set up integrations. */
    function __init() {
      this._integrations = {};
    }
    /** Indicates whether this client's integrations have been set up. */

  }, {
    key: "__init2",
    value: function __init2() {
      this._integrationsInitialized = false;
    }
    /** Number of calls being processed */

  }, {
    key: "__init3",
    value: function __init3() {
      this._numProcessing = 0;
    }
    /** Holds flushable  */

  }, {
    key: "__init4",
    value: function __init4() {
      this._outcomes = {};
    }
  }, {
    key: "captureException",
    value: function captureException(exception, hint, scope) {
      var _this = this;

      // ensure we haven't captured this very object before
      if (checkOrSetAlreadyCaught(exception)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log(ALREADY_SEEN_ERROR);
        return;
      }

      var eventId = hint && hint.event_id;

      this._process(this.eventFromException(exception, hint).then(function (event) {
        return _this._captureEvent(event, hint, scope);
      }).then(function (result) {
        eventId = result;
      }));

      return eventId;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "captureMessage",
    value: function captureMessage(message, level, hint, scope) {
      var _this2 = this;

      var eventId = hint && hint.event_id;
      var promisedEvent = isPrimitive(message) ? this.eventFromMessage(String(message), level, hint) : this.eventFromException(message, hint);

      this._process(promisedEvent.then(function (event) {
        return _this2._captureEvent(event, hint, scope);
      }).then(function (result) {
        eventId = result;
      }));

      return eventId;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "captureEvent",
    value: function captureEvent(event, hint, scope) {
      // ensure we haven't captured this very object before
      if (hint && hint.originalException && checkOrSetAlreadyCaught(hint.originalException)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log(ALREADY_SEEN_ERROR);
        return;
      }

      var eventId = hint && hint.event_id;

      this._process(this._captureEvent(event, hint, scope).then(function (result) {
        eventId = result;
      }));

      return eventId;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "captureSession",
    value: function captureSession(session) {
      if (!this._isEnabled()) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('SDK not enabled, will not capture session.');
        return;
      }

      if (!(typeof session.release === 'string')) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Discarded session because of missing or non-string release');
      } else {
        this.sendSession(session); // After sending, we set init false to indicate it's not the first occurrence

        updateSession(session, {
          init: false
        });
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getDsn",
    value: function getDsn() {
      return this._dsn;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getOptions",
    value: function getOptions() {
      return this._options;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getTransport",
    value: function getTransport() {
      return this._transport;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "flush",
    value: function flush(timeout) {
      var transport = this._transport;

      if (transport) {
        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
          return transport.flush(timeout).then(function (transportFlushed) {
            return clientFinished && transportFlushed;
          });
        });
      } else {
        return resolvedSyncPromise(true);
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "close",
    value: function close(timeout) {
      var _this3 = this;

      return this.flush(timeout).then(function (result) {
        _this3.getOptions().enabled = false;
        return result;
      });
    }
    /**
     * Sets up the integrations
     */

  }, {
    key: "setupIntegrations",
    value: function setupIntegrations() {
      if (this._isEnabled() && !this._integrationsInitialized) {
        this._integrations = _setupIntegrations(this._options.integrations);
        this._integrationsInitialized = true;
      }
    }
    /**
     * Gets an installed integration by its `id`.
     *
     * @returns The installed integration or `undefined` if no integration with that `id` was installed.
     */

  }, {
    key: "getIntegrationById",
    value: function getIntegrationById(integrationId) {
      return this._integrations[integrationId];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getIntegration",
    value: function getIntegration(integration) {
      try {
        return this._integrations[integration.id] || null;
      } catch (_oO) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn("Cannot retrieve integration ".concat(integration.id, " from the current Client"));
        return null;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "sendEvent",
    value: function sendEvent(event) {
      var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this._dsn) {
        var env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

        var _iterator = _createForOfIteratorHelper(hint.attachments || []),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var attachment = _step.value;
            env = addItemToEnvelope(env, createAttachmentEnvelopeItem(attachment, _optionalChain([this, 'access', function (_) {
              return _._options;
            }, 'access', function (_2) {
              return _2.transportOptions;
            }, 'optionalAccess', function (_3) {
              return _3.textEncoder;
            }])));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this._sendEnvelope(env);
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "sendSession",
    value: function sendSession(session) {
      if (this._dsn) {
        var env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);

        this._sendEnvelope(env);
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "recordDroppedEvent",
    value: function recordDroppedEvent(reason, category) {
      if (this._options.sendClientReports) {
        // We want to track each category (error, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        // With typescript 4.1 we could even use template literal types
        var key = "".concat(reason, ":").concat(category);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("Adding outcome: \"".concat(key, "\"")); // The following works because undefined + 1 === NaN and NaN is falsy

        this._outcomes[key] = this._outcomes[key] + 1 || 1;
      }
    }
    /** Updates existing session based on the provided event */

  }, {
    key: "_updateSessionFromEvent",
    value: function _updateSessionFromEvent(session, event) {
      var crashed = false;
      var errored = false;
      var exceptions = event.exception && event.exception.values;

      if (exceptions) {
        errored = true;

        var _iterator2 = _createForOfIteratorHelper(exceptions),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var ex = _step2.value;
            var mechanism = ex.mechanism;

            if (mechanism && mechanism.handled === false) {
              crashed = true;
              break;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } // A session is updated and that session update is sent in only one of the two following scenarios:
      // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
      // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update


      var sessionNonTerminal = session.status === 'ok';
      var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;

      if (shouldUpdateAndSend) {
        updateSession(session, _objectSpread(_objectSpread({}, crashed && {
          status: 'crashed'
        }), {}, {
          errors: session.errors || Number(errored || crashed)
        }));
        this.captureSession(session);
      }
    }
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */

  }, {
    key: "_isClientDoneProcessing",
    value: function _isClientDoneProcessing(timeout) {
      var _this4 = this;

      return new SyncPromise(function (resolve) {
        var ticked = 0;
        var tick = 1;
        var interval = setInterval(function () {
          if (_this4._numProcessing == 0) {
            clearInterval(interval);
            resolve(true);
          } else {
            ticked += tick;

            if (timeout && ticked >= timeout) {
              clearInterval(interval);
              resolve(false);
            }
          }
        }, tick);
      });
    }
    /** Determines whether this SDK is enabled and a valid Dsn is present. */

  }, {
    key: "_isEnabled",
    value: function _isEnabled() {
      return this.getOptions().enabled !== false && this._dsn !== undefined;
    }
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */

  }, {
    key: "_prepareEvent",
    value: function _prepareEvent(event, hint, scope) {
      var _this5 = this;

      var _this$getOptions = this.getOptions(),
          _this$getOptions$norm = _this$getOptions.normalizeDepth,
          normalizeDepth = _this$getOptions$norm === void 0 ? 3 : _this$getOptions$norm,
          _this$getOptions$norm2 = _this$getOptions.normalizeMaxBreadth,
          normalizeMaxBreadth = _this$getOptions$norm2 === void 0 ? 1000 : _this$getOptions$norm2;

      var prepared = _objectSpread(_objectSpread({}, event), {}, {
        event_id: event.event_id || hint.event_id || uuid4(),
        timestamp: event.timestamp || dateTimestampInSeconds()
      });

      this._applyClientOptions(prepared);

      this._applyIntegrationsMetadata(prepared); // If we have scope given to us, use it as the base for further modifications.
      // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.


      var finalScope = scope;

      if (hint.captureContext) {
        finalScope = Scope.clone(finalScope).update(hint.captureContext);
      } // We prepare the result here with a resolved Event.


      var result = resolvedSyncPromise(prepared); // This should be the last thing called, since we want that
      // {@link Hub.addEventProcessor} gets the finished prepared event.

      if (finalScope) {
        // Collect attachments from the hint and scope
        var attachments = [].concat(_toConsumableArray(hint.attachments || []), _toConsumableArray(finalScope.getAttachments()));

        if (attachments.length) {
          hint.attachments = attachments;
        } // In case we have a hub we reassign it.


        result = finalScope.applyToEvent(prepared, hint);
      }

      return result.then(function (evt) {
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
          return _this5._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        }

        return evt;
      });
    }
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */

  }, {
    key: "_normalizeEvent",
    value: function _normalizeEvent(event, depth, maxBreadth) {
      if (!event) {
        return null;
      }

      var normalized = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, event), event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(function (b) {
          return _objectSpread(_objectSpread({}, b), b.data && {
            data: normalize(b.data, depth, maxBreadth)
          });
        })
      }), event.user && {
        user: normalize(event.user, depth, maxBreadth)
      }), event.contexts && {
        contexts: normalize(event.contexts, depth, maxBreadth)
      }), event.extra && {
        extra: normalize(event.extra, depth, maxBreadth)
      }); // event.contexts.trace stores information about a Transaction. Similarly,
      // event.spans[] stores information about child Spans. Given that a
      // Transaction is conceptually a Span, normalization should apply to both
      // Transactions and Spans consistently.
      // For now the decision is to skip normalization of Transactions and Spans,
      // so this block overwrites the normalized event to add back the original
      // Transaction information prior to normalization.


      if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace; // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it

        if (event.contexts.trace.data) {
          normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
        }
      } // event.spans[].data may contain circular/dangerous data so we need to normalize it


      if (event.spans) {
        normalized.spans = event.spans.map(function (span) {
          // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
          if (span.data) {
            span.data = normalize(span.data, depth, maxBreadth);
          }

          return span;
        });
      }

      return normalized;
    }
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */

  }, {
    key: "_applyClientOptions",
    value: function _applyClientOptions(event) {
      var options = this.getOptions();
      var environment = options.environment,
          release = options.release,
          dist = options.dist,
          _options$maxValueLeng = options.maxValueLength,
          maxValueLength = _options$maxValueLeng === void 0 ? 250 : _options$maxValueLeng;

      if (!('environment' in event)) {
        event.environment = 'environment' in options ? environment : 'production';
      }

      if (event.release === undefined && release !== undefined) {
        event.release = release;
      }

      if (event.dist === undefined && dist !== undefined) {
        event.dist = dist;
      }

      if (event.message) {
        event.message = truncate(event.message, maxValueLength);
      }

      var exception = event.exception && event.exception.values && event.exception.values[0];

      if (exception && exception.value) {
        exception.value = truncate(exception.value, maxValueLength);
      }

      var request = event.request;

      if (request && request.url) {
        request.url = truncate(request.url, maxValueLength);
      }
    }
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */

  }, {
    key: "_applyIntegrationsMetadata",
    value: function _applyIntegrationsMetadata(event) {
      var integrationsArray = Object.keys(this._integrations);

      if (integrationsArray.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [].concat(_toConsumableArray(event.sdk.integrations || []), integrationsArray);
      }
    }
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */

  }, {
    key: "_captureEvent",
    value: function _captureEvent(event) {
      var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var scope = arguments.length > 2 ? arguments[2] : undefined;
      return this._processEvent(event, hint, scope).then(function (finalEvent) {
        return finalEvent.event_id;
      }, function (reason) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn(reason);
        return undefined;
      });
    }
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */

  }, {
    key: "_processEvent",
    value: function _processEvent(event, hint, scope) {
      var _this6 = this;

      var _this$getOptions2 = this.getOptions(),
          beforeSend = _this$getOptions2.beforeSend,
          sampleRate = _this$getOptions2.sampleRate;

      if (!this._isEnabled()) {
        return rejectedSyncPromise(new SentryError('SDK not enabled, will not capture event.'));
      }

      var isTransaction = event.type === 'transaction'; // 1.0 === 100% events are sent
      // 0.0 === 0% events are sent
      // Sampling for transaction happens somewhere else

      if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
        this.recordDroppedEvent('sample_rate', 'error');
        return rejectedSyncPromise(new SentryError("Discarding event because it's not included in the random sample (sampling rate = ".concat(sampleRate, ")")));
      }

      return this._prepareEvent(event, hint, scope).then(function (prepared) {
        if (prepared === null) {
          _this6.recordDroppedEvent('event_processor', event.type || 'error');

          throw new SentryError('An event processor returned null, will not send event.');
        }

        var isInternalException = hint.data && hint.data.__sentry__ === true;

        if (isInternalException || isTransaction || !beforeSend) {
          return prepared;
        }

        var beforeSendResult = beforeSend(prepared, hint);
        return _ensureBeforeSendRv(beforeSendResult);
      }).then(function (processedEvent) {
        if (processedEvent === null) {
          _this6.recordDroppedEvent('before_send', event.type || 'error');

          throw new SentryError('`beforeSend` returned `null`, will not send event.');
        }

        var session = scope && scope.getSession();

        if (!isTransaction && session) {
          _this6._updateSessionFromEvent(session, processedEvent);
        }

        _this6.sendEvent(processedEvent, hint);

        return processedEvent;
      }).then(null, function (reason) {
        if (reason instanceof SentryError) {
          throw reason;
        }

        _this6.captureException(reason, {
          data: {
            __sentry__: true
          },
          originalException: reason
        });

        throw new SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ".concat(reason));
      });
    }
    /**
     * Occupies the client with processing and event
     */

  }, {
    key: "_process",
    value: function _process(promise) {
      var _this7 = this;

      this._numProcessing += 1;
      void promise.then(function (value) {
        _this7._numProcessing -= 1;
        return value;
      }, function (reason) {
        _this7._numProcessing -= 1;
        return reason;
      });
    }
    /**
     * @inheritdoc
     */

  }, {
    key: "_sendEnvelope",
    value: function _sendEnvelope(envelope) {
      if (this._transport && this._dsn) {
        this._transport.send(envelope).then(null, function (reason) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Error while sending event:', reason);
        });
      } else {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Transport disabled');
      }
    }
    /**
     * Clears outcomes on this client and returns them.
     */

  }, {
    key: "_clearOutcomes",
    value: function _clearOutcomes() {
      var outcomes = this._outcomes;
      this._outcomes = {};
      return Object.keys(outcomes).map(function (key) {
        var _key$split = key.split(':'),
            _key$split2 = _slicedToArray(_key$split, 2),
            reason = _key$split2[0],
            category = _key$split2[1];

        return {
          reason: reason,
          category: category,
          quantity: outcomes[key]
        };
      });
    }
    /**
     * @inheritDoc
     */

  }]);

  return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */


function _ensureBeforeSendRv(rv) {
  var nullErr = '`beforeSend` method has to return `null` or a valid event.';

  if (isThenable(rv)) {
    return rv.then(function (event) {
      if (!(isPlainObject(event) || event === null)) {
        throw new SentryError(nullErr);
      }

      return event;
    }, function (e) {
      throw new SentryError("beforeSend rejected with ".concat(e));
    });
  } else if (!(isPlainObject(rv) || rv === null)) {
    throw new SentryError(nullErr);
  }

  return rv;
}

export { BaseClient };